import { useEffect, useState } from "react";
import axios from "axios";
import { ACCESS_KEY } from "../config";

function DeviceBanList() {
  const [search, setSearch] = useState("");
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const devicesPerPage = 20;

  useEffect(() => {
    getBannedDevices();
  }, []);

  // 1. Saari Banned Devices Fetch karne ka function
  const getBannedDevices = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://admin.butterlive.co.in/management/device-ban-list",
        {
          headers: {
            key: ACCESS_KEY,
          },
        }
      );
      if (response.data.status) {
        setDevices(response.data.data);
      }
    } catch (error) {
      console.log("Error fetching banned devices:", error);
    } finally {
      setLoading(false);
    }
  };

  // 2. Direct List se hi Unban karne ka function
  const handleDeviceUnban = async (deviceId) => {
    if (!window.confirm(`Are you sure you want to UNBAN this device?`)) return;

    try {
      const response = await axios.post(
        "https://admin.butterlive.co.in/management/device-unban",
        { deviceId: deviceId },
        {
          headers: {
            key: ACCESS_KEY,
          },
        }
      );

      alert(response.data.message);
      // Unban hone ke baad list ko refresh karein
      getBannedDevices();
    } catch (error) {
      console.log(error);
      alert("Error unbanning device");
    }
  };

  // 3. Filter aur Pagination Logic
  const filteredDevices = devices.filter((device) =>
    String(device.deviceId || "").toLowerCase().includes(search.toLowerCase()) ||
    String(device.reason || "").toLowerCase().includes(search.toLowerCase())
  );

  const indexOfLastDevice = currentPage * devicesPerPage;
  const indexOfFirstDevice = indexOfLastDevice - devicesPerPage;
  const currentDevices = filteredDevices.slice(indexOfFirstDevice, indexOfLastDevice);
  const totalPages = Math.ceil(filteredDevices.length / devicesPerPage) || 1;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Banned Devices List</h1>
      </div>

      <div className="top-bar">
        <input
          type="text"
          placeholder="Search Device ID / Reason"
          className="search-box"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1); // Search karne par page 1 par laayein
          }}
        />
      </div>

      <div className="table-card">
        {loading ? (
          <p style={{ padding: "20px", color: "#9ca3af" }}>Loading banned devices...</p>
        ) : (
          <table width="100%" cellPadding="12" style={{ minWidth: "1000px" }}>
            <thead>
              <tr>
                <th width="80">Sr No</th>
                <th>Name</th>
                <th>User ID</th>
                <th>Device ID (Hardware ID)</th>
                <th>Banned Reason</th>
                <th width="150">Status</th>
                <th width="180">Action</th>
              </tr>
            </thead>

            <tbody>
              {currentDevices.length > 0 ? (
                currentDevices.map((device, index) => (
                  <tr key={device._id || index}>
                    <td>{indexOfFirstDevice + index + 1}</td>
                    <td style={{ color: "#22c55e", fontWeight: "600" }}>{device.name}</td>
                    <td style={{ color: "#e5e7eb" }}>{device.uniqueId}</td>

                    <td style={{ wordBreak: "break-all", color: "#fff" }}>
                      {device.deviceId}
                    </td>
                    <td style={{ color: "#9ca3af" }}>
                      {device.reason || "Violation of guidelines"}
                    </td>
                    <td>
                      <span className="status-banned">Banned</span>
                    </td>
                    <td>
                      <button
                        onClick={() => handleDeviceUnban(device.deviceId)}
                        className="ban-btn ban-btn-unban"
                      >
                        Unban Device
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="no-data" style={{ textAlign: "center", padding: "30px", color: "#9ca3af" }}>
                    No banned devices found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}

        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Previous
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeviceBanList;
